module.exports = __webpack_public_path__ + "static/img/7.9199ff0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/honour/7.jpg
// module id = xK79
// module chunks = 1